import { AxiosRequestConfig } from 'axios'
import {
  ConfigResponse,
  DownTimeResponse,
  VideoResponse
} from 'services/assets/typings'
import apiRequestor from 'services/apiRequestor'
import endPoint from 'const/endPoint'
import { DynamicContent } from 'typings/dynamicContent'
import { CommonConfig } from 'typings/commonConfig'

const fetchConfig = async (): Promise<ConfigResponse> => {
  try {
    const requestConfig: AxiosRequestConfig = {
      url: `/commercial/config-3.json`,
      method: 'GET'
    }

    const response = await apiRequestor<CommonConfig>({
      apiType: 'ASSETS',
      requestConfig
    })
    return { data: response.data }
  } catch (error) {
    // common config unavailable
    return { error }
  }
}

/** fetch immediately */
const configPromise = fetchConfig()

const assetsAPI = {
  getVideoList: async (videoPath: string): Promise<VideoResponse> => {
    const requestConfig: AxiosRequestConfig = {
      url: videoPath,
      method: 'GET'
    }

    const response = await apiRequestor<VideoResponse>({
      apiType: 'ASSETS',
      requestConfig,
      hasAccountInfo: false,
      isBadRequestAllowed: true
    })

    return response.data
  },
  getMaintenanceStatus: async (): Promise<DownTimeResponse> => {
    const requestConfig: AxiosRequestConfig = {
      url: endPoint.downTime,
      method: 'GET'
    }

    const response = await apiRequestor<DownTimeResponse>({
      apiType: 'ASSETS',
      requestConfig,
      hasAccountInfo: false,
      isBadRequestAllowed: true
    })

    return response.data
  },
  getDynamicContent: async (
    clientName: ClientKeys | 'common'
  ): Promise<DynamicContent | null> => {
    try {
      const requestConfig: AxiosRequestConfig = {
        url: `/commercial/${clientName}/dynamic-content.json`,
        method: 'GET'
      }

      const response = await apiRequestor<DynamicContent>({
        apiType: 'ASSETS',
        requestConfig
      })
      return response.data
    } catch (error) {
      // dynamic content unavailable
      return null
    }
  },
  /** returns promise for the Common Config JSON */
  getConfig: () => configPromise
}
export default assetsAPI
